module.exports = __webpack_public_path__ + "static/img/Coins.f2a5015.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Coins.png
// module id = EMrM
// module chunks = 1